<template>
  <a-modal
    title="添加回款金额"
    :confirmLoading="loading"
    :destroyOnClose="true"
    v-model="visible"
    @ok="handleOk"
  >
    <a-form :form="form">
      <a-form-item label="回款金额" v-bind="formItemsLayout">
        <a-input
          addonAfter="元"
          v-decorator="[
            'amount',
            {
              rules: [
                { required: true, message: '请填写回款金额' },
                {
                  transform(value) {
                    return +value;
                  },
                  type: 'number',
                  message: '请填写数字'
                }
              ]
            }
          ]"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "AddReturnModal",
  data() {
    return {
      visible: false,
      loading: false,
      record: {},
      form: this.$form.createForm(this),
      formItemsLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      }
    };
  },
  methods: {
    show(record) {
      this.record = { ...record };
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            await Api.order.payment({
              ...values,
              post_id: this.record.id
            });
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    }
  }
};
</script>
